import CiroPill from "../shared/CiroPill";
import classNames from "classnames";
import { ArrowsPointingOutIcon, FireIcon } from "@heroicons/react/24/outline";
import approx from "approximate-number";
import { gql } from "@apollo/client";
import { AutopilotPreviewSubheaderActions_AutopilotSessionPreviewResponseFragment } from "../../__generated__/graphql";
import CiroButton, { CiroButtonStyleEnum } from "../shared/CiroButton";
import AutopilotExpandSearchModal from "../automation/AutopilotExpandSearchModal";
import { useState } from "react";

export const AutopilotPreviewSubheaderActions_AutopilotSessionPreviewResponse = gql`
  fragment AutopilotPreviewSubheaderActions_AutopilotSessionPreviewResponse on AutopilotSessionPreviewResponse {
    multisearchDetail {
      contactCountFromPreviewCompanies
      numPreviewCompanies
      numTotalCompanies
    }
    totalContacts
  }
`;

const AutopilotPreviewSubheaderActions = ({
  autopilotSessionPreview,
  curatedSearchId,
}: {
  autopilotSessionPreview: AutopilotPreviewSubheaderActions_AutopilotSessionPreviewResponseFragment | null;
  curatedSearchId: number | null;
}) => {
  const [isExpandSearchModalOpen, setIsExpandSearchModalOpen] = useState(false);

  if (!autopilotSessionPreview?.totalContacts) {
    return null;
  }

  return (
    <>
      <CiroPill background="bg-orange-100" fontColor="text-orange-500">
        <div className={classNames("flex", "items-center", "gap-1")}>
          <FireIcon className={classNames("h-3")} />
          <div>
            {autopilotSessionPreview?.multisearchDetail ? (
              <>
                {autopilotSessionPreview.multisearchDetail
                  ?.contactCountFromPreviewCompanies &&
                  autopilotSessionPreview.multisearchDetail
                    ?.contactCountFromPreviewCompanies > 1000 &&
                  "+"}
                {approx(
                  autopilotSessionPreview.multisearchDetail
                    ?.contactCountFromPreviewCompanies || 0,
                )}{" "}
                found from first{" "}
                {autopilotSessionPreview.multisearchDetail?.numPreviewCompanies}{" "}
                companies (
                {autopilotSessionPreview.multisearchDetail?.numTotalCompanies}{" "}
                companies total to be searched)
              </>
            ) : (
              <>
                {autopilotSessionPreview?.totalContacts &&
                  autopilotSessionPreview.totalContacts > 1000 &&
                  "+"}
                {approx(autopilotSessionPreview?.totalContacts || 0)} potential
                matches
              </>
            )}
          </div>
        </div>
      </CiroPill>
      <CiroButton
        style={CiroButtonStyleEnum.UNSTYLED}
        analyticsField="Expand search"
        onClick={() => setIsExpandSearchModalOpen(true)}
      >
        <div
          className={classNames(
            "flex",
            "items-center",
            "gap-2",
            "text-xs",
            "text-orange-500",
            "font-medium",
            "rounded-lg",
            "px-2",
            "py-1",
            "hover:bg-gray-200",
            "cursor-pointer",
          )}
        >
          <ArrowsPointingOutIcon className={classNames("h-4")} />
          <span>Expand this search</span>
        </div>
      </CiroButton>
      <AutopilotExpandSearchModal
        curatedSearchId={isExpandSearchModalOpen ? curatedSearchId : null}
        onClose={() => setIsExpandSearchModalOpen(false)}
      />
    </>
  );
};

export default AutopilotPreviewSubheaderActions;
